import React, { createContext, useContext, useState } from 'react';

interface NotifCtx {
    hasUnread: boolean;
    clearUnread: () => void;
}

const NotifContext = createContext<NotifCtx>({ hasUnread: true, clearUnread: () => {} });

export const NotifProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [hasUnread, setHasUnread] = useState(true); // resets to true on every refresh

    return (
        <NotifContext.Provider value={{ hasUnread, clearUnread: () => setHasUnread(false) }}>
            {children}
        </NotifContext.Provider>
    );
};

export const useNotif = () => useContext(NotifContext);